// import Img from '@components/Img';
import { Section, SectionContainer } from '@components/Section';
import Column from '@components/Column/Column';
import Text from '@hiredigital/ui/Text/Text';
import Img from '@components/Img';
import Styles from './Styles.module.scss';

const baseData = {
  title: `Why the Highest Performing Companies Work With Hire Digital`,
  description: `Hire Digital works with the most forward thinking companies globally, from Fortune 500 enterprises to fast-growing businesses.`,
  benefits: [
    {
      title: `Rigorous screening`,
      description: `Each talent is screened thoroughly for their track record and subject expertise. Only the top decile who apply are accepted.`,
    },
    {
      title: `On-demand`,
      description: `Hire your talent exactly when you need them. Hire and scale your team without interrupting project timelines.`,
    },
    {
      title: `Domain expertise`,
      description: `Access talent with the track record, skillsets and domain expertise to take your project to the next level.`,
    },
    {
      title: `Cost effective`,
      description: `Say goodbye to excessive overheads. Reduce marketing costs by up to 70%.`,
    },
    {
      title: `Risk-free`,
      description:
        "It's entirely risk-free. We provide a suite of options to guarantee you quality talent and project satisfaction.",
    },
    {
      title: `Easy communication`,
      description: `Communicate with our talent as if they are a part of your core team, with tools and resources to ensure seamless workflow.`,
    },
  ],
};

const WhyWork = ({ data = baseData, textColor }) => {
  return (
    <SectionContainer anchor='why'>
      <Section>
        <Text element='h2' size={Text.Size.SUBHEADLINE_LARGE} style={{ color: textColor }}>
          {data.title}
        </Text>
        <Text element='p' style={{ color: textColor, marginBottom: '30px' }}>
          {data.description}
        </Text>
        <Column.List isCardList>
          {data?.benefits.map((benefit, index) => {
            return (
              <Column.Card key={index}>
                {benefit?.icon && (
                  <Column.Image type={Column.Image.Type.ICON}>
                    <Img className={Styles.image} alt='icon' src={benefit?.icon?.url} />
                  </Column.Image>
                )}

                <Column.Headline>{benefit?.title}</Column.Headline>
                <Column.Content>{benefit?.description}</Column.Content>
              </Column.Card>
            );
          })}
        </Column.List>
      </Section>
    </SectionContainer>
  );
};

export default WhyWork;
